import { format, parse } from "date-fns";
import React, { useMemo, useState } from "react";
import { connect } from "react-redux";
import PeoplesPensionGroupImport from "./PeoplesPensionGroupImport";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

const schemeTypeOptions = {
	"Qualifying Earnings": "type1",
	"Pensionable Earnings": "banded",
	"Total Earnings": "type3",
	"Fixed Amount": "unbanded",
};

const PeoplesPensionSchemeImport = ({ schemes: pensionSchemes, groups: pensionGroups, buddySchemes }) => {
	const [expandScheme, setExpandScheme] = useState({});
	const { schemes, groups } = useMemo(() => {
		return { schemes: pensionSchemes, groups: pensionGroups };
	}, [JSON.stringify(pensionSchemes), JSON.stringify(pensionGroups)]);

	if (!schemes?.length) return null;
	return (
		<div className="form-inner-section px-0 mx-0">
			<div
				style={{
					display: "grid",
					gridGap: "1.5rem",
					grid: "1.5rem",
					gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
					padding: "1rem",
					borderBottom: "solid rgb(244,244,244) 4px",
				}}
			>
				<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", opacity: "0.75" }}>
					<h5>Scheme</h5>
				</div>
				<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", opacity: "0.75" }}>
					<h5>Pay Schedule</h5>
				</div>
				<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", opacity: "0.75" }}>
					<h5>Relief/Scheme</h5>
				</div>
				<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", opacity: "0.75" }}>
					<h5>Status</h5>
				</div>
			</div>
			{schemes?.map?.((item, index) => {
				const { label, value, paySchedule, reliefType, isDisabled, stagingDate, schemeType } = item;
				const imported = !!buddySchemes?.find(
					(s) => s.connectionId === value && s.schemeType === schemeTypeOptions[schemeType],
				);
				const groupOptions = groups?.filter((group) => group.scheme == value && group.schemeType == schemeType);
				const scheme = `${value}${schemeType}`;
				const expanded = expandScheme[`${value}${schemeType}`];
				const isLast = index + 1 == schemes.length;
				return (
					<>
						<div
							key={`scheme${scheme}`}
							style={{
								display: "grid",
								gridGap: "1.5rem",
								grid: "1.5rem",
								gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
								padding: "1rem",
								borderBottom: isLast || expanded ? undefined : "solid rgb(244,244,244) 4px",
							}}
						>
							<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", paddingLeft: "1rem" }}>
								<h5>{label}</h5>
								<p style={{ marginBottom: 0 }}>
									{stagingDate
										? format(parse(stagingDate, "yyyy-MM-dd", new Date()), "dd MMM yyyy")
										: null}
								</p>
							</div>
							<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", paddingTop: "1rem" }}>
								<h5>{paySchedule}</h5>
							</div>
							<div style={{ gridColumn: "span 1 / span 4", textAlign: "center" }}>
								<h5>{reliefType}</h5>
								<div className="badge badge-primary">{schemeType}</div>
							</div>
							<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", paddingTop: "1rem" }}>
								{isDisabled ? <div className="badge badge-default">Not Supported by API</div> : null}
								{imported ? <div className="badge badge-success">Imported</div> : null}
								{!imported ? <div className="badge">Not Imported</div> : null}
								{/* {!imported && !isDisabled ? <button
                                className="btn btn-xs btn-default"
                                onClick={() => console.log('import')}
                            >
                                Import
                            </button> : null} */}
								{groups?.length ? (
									<button
										className="btn btn-xs btn-default"
										style={{ marginLeft: 10 }}
										onClick={() => {
											setExpandScheme({ ...expandScheme, [scheme]: !expanded });
										}}
									>
										<ChevronDownIcon
											style={{
												height: "1.5rem",
												float: "left",
												transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
												transition: "transform 0.2s ease-in-out",
											}}
										/>
									</button>
								) : null}
							</div>
						</div>
						{expanded ? (
							<>
								<PeoplesPensionGroupImport
									groups={groupOptions}
									schemeValue={value}
								/>
							</>
						) : null}
					</>
				);
			})}
		</div>
	);
};

const mapStateToProps = (state) => {
	const { peoplesPension } = { ...state.integration?.pension };
	const { settings, schemes, groups } = { ...peoplesPension };

	return {
		schemes,
		groups,
		buddySchemes: state?.pensions?.scheme?.list,
		settings: settings || {},
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PeoplesPensionSchemeImport);
